import React, { useEffect, useState } from 'react';
import { SysHomeVo } from '@/api/home/types';
import styles from '../HomePage/index.module.scss';
import { state } from '@/store/index';
import { Chart } from '@antv/g2';
import { overviewByCrmApi } from '@/api/home/home';
import { getPetListApi } from '@/api/petManage/petList';
const HomePage: React.FC = () => {
  // 客户数据
  const [sysCustomerInfo, setSysCustomerInfo] = useState({} as SysHomeVo);
  // 首页标题
  const HeaderText = () => {
    return (
      <div className={styles.HeaderText}>
        <div style={{ lineHeight: '32px' }}>
          {' '}
          Hi，{state.detail.nickName}，Welcome to{' 皇家宠物管理后台'}
        </div>
      </div>
    );
  };
  const CustomerData = ({ sysCustomerInfo }: { sysCustomerInfo: any }) => {
    const cardList = [
      {
        label: '店铺会员数量',
        value: sysCustomerInfo.memberNum ? sysCustomerInfo.memberNum : 0,
      },
      {
        label: '店铺会员宠物数量',
        value: sysCustomerInfo.memberPetNum ? sysCustomerInfo.memberPetNum : 0,
      },
      {
        label: '30日权益发放数量',
        value: sysCustomerInfo.thirtyEquityNum ? sysCustomerInfo.thirtyEquityNum : 0,
      },
      {
        label: '30日积分兑换数量',
        value: sysCustomerInfo.thirtyIntegralNum ? sysCustomerInfo.thirtyIntegralNum : 0,
      },
    ];
    return (
      <div className={styles.CustomerData}>
        <div className={styles.smallCardList}>
          {cardList.map((it: any, index: number) => (
            <div
              className={styles.smallCardItem}
              key={it.label}
              style={{ marginRight: index === cardList.length - 1 ? '0px' : '24px' }}>
              <div className={styles.cardTitle}>{it.label}</div>
              <div className={styles.customerData}>{it.value.toLocaleString('en-US')}</div>
              <img
                className={styles.customerImg}
                src={it.img}
                alt=""
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  const overviewByCrm = async () => {
    let res: any = await overviewByCrmApi(state.currentShopId);
    console.log(res);

    const res1 = await getPetListApi({ shopId: state.currentShopId, pageSize: 10, pageNum: 1 });
    // setTotal(res1.total ?? 0);
    res.data.memberPetNum = res1.total;
    setSysCustomerInfo(res.data);
    let chartData = res.data.memberAddNumList;
    chartData.map((item: any) => {
      item.date = item.date.split('-').splice(1, 2).join('.');
    });

    const chart = new Chart({
      container: 'chart',
      autoFit: true,
    });

    chart
      .data(chartData)
      .encode('x', 'date')
      .encode('y', 'value')
      .interaction('tooltip', {
        render: (event: any, { items }: any) => {
          const target = event.target;
          const format = (item: any) => `新增会员数: ${item.value}`;
          return items.map(format);
        },
      })
      .axis('y', { title: '入会(人)' })
      .axis('x', { title: '日期', labelTransform: 'rotate(0)' });
    chart.line().encode('shape', 'smooth');
    chart.render();
  };

  useEffect(() => {
    overviewByCrm();
  }, []);

  return (
    <div className={styles.homePageContent}>
      <HeaderText />
      <CustomerData sysCustomerInfo={sysCustomerInfo} />
      <div className={styles['newMemberTitle']}>
        <div>新增会员</div>
        <div style={{ fontSize: 16 }}>(近15日)</div>
      </div>
      <div id="chart"></div>
    </div>
  );
};

export default HomePage;
